import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Col, Row, Button, Input, InputGroup, InputGroupText } from "reactstrap";
import { opportunitySources, opportunityStatuses } from "../../config/constants";
import { BsSearch } from "react-icons/bs";
import useMarketingCampaigns from "./useMarketingCampaigns";
import { FaFilter } from "react-icons/fa";
import SelectAllSearch from "../../sharedComponents/Select/SelectAllSearch";

const MarketingCampaignsFiltersCard = (props) => {
    const location = useLocation();
    const opportunitiesList = useSelector(({opportunities}) => opportunities.opportunitiesItems);
    const selectedClientManager = useSelector(({dashboard}) => dashboard.selectedFilters.selectedClientManager);
    const selectedSource = useSelector(({dashboard}) => dashboard.selectedFilters.selectedSource);
    const selectedStatus = useSelector(({dashboard}) => dashboard.selectedFilters.selectedStatus);

    const { clearOpportunityFilters, setSelectedClientManager, setSelectedSource, setSelectedStatus } = useMarketingCampaigns.useMarketingCampaigns();

    const showClearButton = (selectedSource?.length > 0 || selectedClientManager?.length > 0 || selectedStatus?.length > 0 || props?.searchTerm);

    const clientManagerMap = opportunitiesList?.data?.filter((data) => data.clientmanagername).map((data) => {
        return (
            {value: data.clientmanagername, label: data.clientmanagername}
        );
    });

    const selectedClientManagerMap = selectedClientManager?.sort().map((data) => {
        return (
            {value: data, label: data}
        );
    });

    const opportunitiesSourceMap = opportunitySources?.sort().map((data) => {
        return (
            {value: data, label: data}
        );
    });

    const selectedSourceMap = selectedSource?.sort().map((data) => {
        return (
            {value: data, label: data}
        );
    });

    const opportunitiesStatusMap = opportunityStatuses?.sort().map((data) => {
        return (
            {value: data, label: data}
        );
    });

    const selectedStatusMap = selectedStatus?.sort().map((data) => {
        return (
            {value: data, label: data}
        );
    });

    const handleClearFilters = () => {
        clearOpportunityFilters();
        props.setSearchTerm('');
    };

    return (
        <Col className="h-fc mb-2 card" style={{backgroundImage: 'url("FiltersBackground.png")', backgroundSize: 'cover', boxShadow: '0 1px 1px 0 rgba(0, 0, 0, 0.2)', borderRadius: '5px'}}>
            <Row id={`filtersOpportunitiesMain`} className="w-100 mx-0">
                <Col>
                <Col className="w-fc">
                    <div className="main-header text-size-20" style={{color: '#00A6CC', paddingTop: '5px'}}><FaFilter fontSize={'15px'} style={{marginBottom: '5px'}}/> Filters</div>
                </Col>
                    <Row className="px-0">
                        <Col>
                            <Row className="mb-2" style={{'--bs-gutter-y': '8px', whiteSpace: 'nowrap'}}>
                                <Col style={{minWidth: '200px'}}>
                                    <InputGroup className='ps-0' size='md' style={{height: '38px'}}>
                                        <InputGroupText>
                                            <BsSearch/>
                                        </InputGroupText>
                                        <Input className='text-input' id="opportunityStatusSearchInput" placeholder='Search...' value={props?.searchTerm} onChange={(e) => props?.setSearchTerm(e.target.value)}/> 
                                    </InputGroup>
                                </Col>
                                <Col style={{minWidth: '200px'}}>
                                    <SelectAllSearch
                                        isMulti
                                        name='clientManager'
                                        options = {clientManagerMap}
                                        onChange = {(e) => setSelectedClientManager(e)}
                                        value = {selectedClientManagerMap}
                                        placeholder='Select Client Manager'
                                    />
                                </Col>
                                <Col style={{minWidth: '200px'}}>
                                    <SelectAllSearch 
                                        isMulti
                                        name='source' 
                                        options = {opportunitiesSourceMap}
                                        onChange = {(e) => setSelectedSource(e)}
                                        value = {selectedSourceMap}
                                        placeholder='Select Source'
                                    />
                                </Col>
                                <Col style={{minWidth: '200px'}}>
                                    <SelectAllSearch 
                                        isMulti
                                        name='operator' 
                                        options = {opportunitiesStatusMap}
                                        onChange = {(e) => setSelectedStatus(e)}
                                        value = {selectedStatusMap}
                                        placeholder='Select Status'
                                    />
                                </Col>
                                {showClearButton && 
                                <Col className="w-fc">
                                    <Button
                                        outline={false}
                                        block
                                        id="clearFiltersButton"
                                        className="py-2 button-label"
                                        size="sm"
                                        style={{ width: "120px", color: 'white'}}
                                        color='blueFilter'
                                        onClick={handleClearFilters}>
                                        <span style={{fontWeight: '600'}}>Clear Filters</span>
                                    </Button>
                                </Col>
                                }
                                {location?.state && 
                                <Col className='w-fc me-0'>
                                    *Data filtered by {location?.state?.campaignName}
                                </Col>
                                }
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Col>
    )   
}

export default MarketingCampaignsFiltersCard;